import { render, staticRenderFns } from "./bingli.vue?vue&type=template&id=4e270b7a&scoped=true&"
import script from "./bingli.vue?vue&type=script&lang=js&"
export * from "./bingli.vue?vue&type=script&lang=js&"
import style0 from "./bingli.vue?vue&type=style&index=0&id=4e270b7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e270b7a",
  null
  
)

export default component.exports